import HtmlHead from "./htmlHead";

export default HtmlHead;
